export const dateSorter = (key: string) => (a: any, b: any) => {
  if (a[key] === undefined) {
    return 1;
  }

  if (b[key] === undefined) {
    return -1;
  }

  return new Date(a[key]).getTime() - new Date(b[key]).getTime();
};
